import { CurrencyResponse, CurrencyResponseItem } from '@/types/service-response'

export class Currency {
  private constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createListFromResponse (responseData: CurrencyResponse): Array<Currency> {
    return responseData.map((item: CurrencyResponseItem) => {

      return new Currency(
        item.ID,
        item.ISOCode
      )
    })
  }
}
